import { atom } from 'recoil';

export const isNewReceiptModalOpenAtom = atom({
  key: 'isNewReceiptModalOpen',
  default: false,
});
